import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from 'react';

/**
 * Custom hook for managing product search state and functions
 * @param {Object} filterState - Current filter state
 * @param {Object} filterActions - Filter action functions
 * @returns {Object} Product search state and functions
 */
const useProductSearch = (filterState, filterActions) => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      facetFilters: "",
      facets: "*"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== filterState.searchQuery) {
    t1 = {
      query: filterState.searchQuery,
      configure: t0,
      hitsPerPage: 24,
      page: 1
    };
    $[1] = filterState.searchQuery;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [productSearchState, setProductSearchState] = useState(t1);
  let t2;
  if ($[3] !== filterActions) {
    t2 = searchState => {
      setProductSearchState(searchState);
      filterActions.setSearchQuery(searchState.query || "");
    };
    $[3] = filterActions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onSearchUpdate = t2;
  let t3;
  if ($[5] !== filterActions) {
    t3 = () => {
      setProductSearchState(_temp);
      filterActions.setSearchQuery("");
      filterActions.setSelectedProduct(null);
    };
    $[5] = filterActions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const resetProductSearch = t3;
  let t4;
  if ($[7] !== filterActions) {
    t4 = (productId, productName) => {
      if (productId && productName) {
        const newProduct = {
          id: productId,
          name: productName
        };
        filterActions.setSelectedProduct(newProduct);
        filterActions.setSearchQuery(productName);
      } else {
        filterActions.setSelectedProduct(null);
        filterActions.setSearchQuery("");
      }
    };
    $[7] = filterActions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleProductClicked = t4;
  let t5;
  if ($[9] !== filterActions || $[10] !== filterState.searchMaterialFilter) {
    t5 = materialOption => {
      if (materialOption) {
        const newValue = filterState.searchMaterialFilter === materialOption ? "" : materialOption;
        filterActions.setSearchMaterialFilter(newValue);
        filterActions.setSearchQuery(newValue);
      } else {
        filterActions.setSearchMaterialFilter("");
        filterActions.setSearchQuery("");
      }
    };
    $[9] = filterActions;
    $[10] = filterState.searchMaterialFilter;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleMaterialOptionChange = t5;
  let t6;
  if ($[12] !== handleMaterialOptionChange || $[13] !== handleProductClicked || $[14] !== onSearchUpdate || $[15] !== productSearchState || $[16] !== resetProductSearch) {
    t6 = {
      productSearchState,
      onSearchUpdate,
      resetProductSearch,
      handleProductClicked,
      handleMaterialOptionChange
    };
    $[12] = handleMaterialOptionChange;
    $[13] = handleProductClicked;
    $[14] = onSearchUpdate;
    $[15] = productSearchState;
    $[16] = resetProductSearch;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default useProductSearch;
function _temp(prevState) {
  return {
    ...prevState,
    query: ""
  };
}